import { scrollPageBy } from '../pageScroll';

// Checkbox-local scrolling: measure before optimistic completion changes the row.
// Do not move focus or wait for Coach/persistence (both can change independently).
export function scrollDownBySetRow(checkbox) {
  const row = checkbox.closest('tr');
  const height = row?.getBoundingClientRect().height;
  if (!height) return;
  const behavior = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';

  for (let owner = row.parentElement; owner && owner !== document.body && owner !== document.documentElement; owner = owner.parentElement) {
    if (/(auto|scroll|overlay)/.test(window.getComputedStyle(owner).overflowY)
      && owner.scrollHeight > owner.clientHeight) {
      owner.scrollBy({ top: height, behavior });
      return;
    }
  }
  scrollPageBy({ top: height, behavior });
}
